import React, { useState } from 'react'
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip,
    MenuItem,
    Menu,
    Stack, Button,
    InputBase
  } from '@mui/material';
  import Calendar from 'react-calendar/dist/cjs/Calendar.js';
  import { Edit, Delete, ArrowDropDown, Search } from '@mui/icons-material';
  import { styled } from '@mui/material/styles';

import { Filter } from '../../Svg';
import { useDispatch } from 'react-redux';
import { setSampleFromDate, setSampleSearch, setSampleStatus } from '../../redux/sampleRequestSlice';

const SearchInput = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    width: '320px',
    fontFamily: `'Public Sans', sans-serif`,
  }));

  const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    marginRight: theme.spacing(1),
    fontSize: '0.875rem',
    color: '#512DA8',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    fontWeight: '600 !important',
    fontFamily: `'Public Sans', sans-serif`,
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: theme.palette.grey[200],
    },
  }));

const SampleRequestfilter = ({setFromData}) => {
    
  const [showCalendar, setShowCalendar] = useState(false); 
  const dispatch = useDispatch()
  const [statusAnchorEl, setStatusAnchorEl] = useState(null); // State for Status dropdown
  const statusOpen = Boolean(statusAnchorEl);
  
   // Handlers for Status dropdown
   const handleStatusClick = (event) => {
    setStatusAnchorEl(event.currentTarget);
  };

  const handleStatusClose = (status) => {
     dispatch(setSampleStatus(status))
    setStatusAnchorEl(null);
  };
  const handleCalClick = () => {
    setShowCalendar(prevState => !prevState); // Toggle the visibility of the calendar
  };

  return (
    <>
       <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ paddingBottom: '20px' }}>
        <SearchInput >
          <IconButton aria-label="search">
            <Search />
          </IconButton>
          <InputBase placeholder="Search…" onChange={(e)=>dispatch(setSampleSearch(e.target.value))}/>
        </SearchInput>

        <div style={{ display: 'flex' }}>
          {/* Category Dropdown */}
          <div style={{ position: 'relative'}} >
            <ActionButton
              onClick={()=>handleCalClick('')}
              sx={{
                color: '#667085',
                border: '1px solid #E0E2E7',
                background: '#fff',
                borderRadius: '8px',
              }}
            >
              <Filter /> Calender
            </ActionButton>
            {showCalendar && (
              <div className="calender">
                <Calendar onChange={(e)=>{dispatch(setSampleFromDate(e.toLocaleDateString()));handleCalClick()}}/>
              </div>
            )}
          </div>

          {/* Status Dropdown */}
          <div>
            <ActionButton
              onClick={handleStatusClick}
              sx={{
                color: '#667085',
                border: '1px solid #E0E2E7',
                background: '#fff',
                borderRadius: '8px',
              }}
            >
              <Filter /> Status
            </ActionButton>
            <Menu
              anchorEl={statusAnchorEl}
              open={statusOpen}
              onClose={()=>handleStatusClose('')}
              MenuListProps={{
                'aria-labelledby': 'status-button',
              }}
            >
              <MenuItem onClick={()=>handleStatusClose('NEW')}
                sx={{
                  borderBottom: '1px solid #E6E1E5',
                  fontSize: '14px',
                  color: '#667085',
                }}>New
              </MenuItem>
              <MenuItem onClick={()=>handleStatusClose('COMPLETED')}
                sx={{
                  fontSize: '14px',
                  color: '#667085',
                }}>Completed
              </MenuItem>
            </Menu>
          </div>
        </div>
      </Stack> 
    </>
  )
}

export default SampleRequestfilter